export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum Severity {
  INFO = "info",
  WARN = "warn",
  SUCCESS = "success",
  DANGER = "danger",
}

export enum Status {
  ONLINE = "online",
  OFFLINE = "offline",
}

export enum WeekDay {
  MONDAY = "monday",
  TUESDAY = "tuesday",
  WEDNESDAY = "wednesday",
  THURSDAY = "thursday",
  FRIDAY = "friday",
  SATURDAY = "saturday",
  SUNDAY = "sunday",
}

export enum OrderStatus {
  WAITING_FOR_PAYMENT = "waiting_for_payment",
  PROCESSING = "processing",
  COOKING = "cooking",
  WAITING_FOR_RIDER = "waiting_for_rider",
  WAITING_FOR_PICKUP = "waiting_for_pickup",
  DRIVER_ASSIGNED = "driver_assigned",
  COLLECTED = "collected",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export enum OrderType {
  PICKUP = "pickup",
  DELIVERY = "delivery",
}

export enum PayoutType {
  HT = "ht",
  TTC = "ttc",
}

export enum TransportType {
  CAR = "car",
  SCOOTER = "scooter",
  BIKE = "bike",
}

export enum RushOrderType {
  PriorityCount = "priorityCount",
  WaitingForPayment = "waitingForPayment",
  Processing = "processing",
  ProcessingOlderThan10Min = "processingOlderThan10Min",
  Cooking = "cooking",
  WaitingForRider = "waitingForRider",
  DriverAssigned = "driverAssigned",
  DeliveryCollected = "deliveryCollected",
  DeliveryCollected40to50 = "deliveryCollected40to50",
  DeliveryCollected50to60 = "deliveryCollected50to60",
  DeliveryCollected60to90 = "deliveryCollected60to90",
  DeliveryCollected90to120 = "deliveryCollected90to120",
  DeliveryCollectedOver120 = "deliveryCollectedOver120",
}

export enum FeeType {
  DELIVERY = "delivery",
  SMALL_ORDER = "small_order",
  SERVICE = "service",
}
